module.exports = __webpack_public_path__ + "img/canvas-bg2.d312a1ee.png";